import React from "react";
const PrivacyPolicy = () => {
  return (
    <>
      <article className="pageBody">
        <h2>Privacy Policy</h2>
        <div className="homeText">
          <h3> Privacy Notice for GTW Hypnotherapy </h3>
          <p>
            The following information explains how I collect, use and protect
            any personal data that you provide to me. I may change and update
            this privacy policy at any time by updating this privacy notice. If
            any significant changes are made I will make this clear on my
            website or I may contact you directly
          </p>
          <h3> About Me </h3>
          <p>
            I am sole trader and data controller of the information I hold and
            process about individuals who have expressed an interest in my
            hypnotherapy service.
          </p>{" "}
          <h3>About the individuals whose data I collect</h3>{" "}
          <p>I collect data about individuals who: </p>
          <ul>
            <li> Enquire about and/or attend hypnotherapy sessions </li>
            <li>
              Enquire about and/or attend my relaxation classes, workshops and
              other occasional events
            </li>
          </ul>{" "}
          <h3>What I do with personal data </h3>
          <p>The legal basis for processing your data is as follows: </p>
          <ul>
            <li>
              Contractual obligations in communicating therapy related
              information eg booking appointments, recording progress.
            </li>
            <li>
              Consent from individuals who participate in the CORP research
              programme, which tracks therapeutic progress.
            </li>
            <li>
              {" "}
              Legitimate interest in communicating information about relaxation
              classes, workshops, and other events.
            </li>
            <li>Legitimate interest for financial accounting purposes.</li>
          </ul>
          <h3>Storage of personal data</h3>
          <p> I hold data in both written and electric form. </p>
          <p>Written data collected: </p>
          <ul>
            <li>
              From individuals, if they enquire by telephone or text, in which
              case, I hand-write contact details and brief notes in order to
              make contact.
            </li>
            <li>
              {" "}
              From clients, during the Initial Consultation and subsequent
              therapy sessions.
            </li>
            <li>
              {" "}
              Written data is stored securely in a locked filing cabinet in my
              locked therapy room.
            </li>{" "}
            <li>
              Relevant data is transferred to electronic format for the purposes
              of recording attendance and bookkeeping.
            </li>
          </ul>
          <p>
            Electronic data is held in spreadsheets on a password-protected
            laptop.
          </p>
          <p>Client data is anonymised.</p>
          <p>
            {" "}
            For clients participating in the CORP research programme, I use the
            CORP specialist software to track client progress. Client data is
            anonymised before being stored in the CORP database. The anonymised
            CORP data is stored on my password-protected laptop and is
            periodically uploaded into a centralised ‘cloud’ of industry-wide
            data for research purposes.{" "}
          </p>
          <p>
            Electronic data is also held within a proprietary Email Management
            system for the purposes of notifying you of my events and
            opportunities that may be of interest.{" "}
          </p>
          <p>
            Electronic data within emails, text messages, voicemail and social
            media direct messages is held securely using leading service
            providers such as Facebook and Outlook, and is accessed via
            password-protected use accounts, mobile phones and laptops.
          </p>
          <h3>Sharing your personal data </h3>
          <p>
            Email Management System providers to help me communicate with you.
            Payment Gateways to process financial transactions. These providers
            have access to your personal information so that they can perform
            their functions on my behalf, but they may not use it for other
            purposes. I am professionally obliged to report to relevant
            authorities if I have concerns that you may cause harm to yourself,
            to others, or to me.
          </p>{" "}
          <p>
            To ensure best practice I may from time to time discuss your
            progress with a supervisor, in which case I would not divulge your
            identity. With the above exceptions, I will never share your data
            with a third party without your express permission, unless legally
            required to do so. Times, when I might seek your consent to share
            your data, may include; making a referral to another therapist or
            medical practitioner
          </p>{" "}
          <h3>Your rights </h3>
          <p>
            You have the following rights under the General Data Protection
            Regulations:{" "}
          </p>
          <ul>
            <li> To request a copy of the information I hold about you </li>
            <li>
              {" "}
              To update any of your personal information if it is inaccurate or
              out of date{" "}
            </li>
            <li>
              {" "}
              To request that I delete the personal data I hold about you{" "}
            </li>
            <li> To restrict the way in which I process your personal data </li>
            <li>
              {" "}
              To request that I stop processing your data if you object to me
              doing so{" "}
            </li>
            <li> To ask me to transfer your personal data to a third party</li>
          </ul>
          <h3>Data Retention</h3>
          <p>
            {" "}
            I will keep your personal data for no longer than necessary for the
            purposes of providing my service to you and to fulfil my obligations
            for financial and insurance record keeping. I am required by my
            governing association membership to keep records of my clients for
            adults for 6 years from the completion of their therapy. For clients
            under the age of 18, we are required by GDPR law to keep records
            until they turn 21 or for 6 years from the end of their therapy
            (whichever is greater). This includes both information about why you
            are seeking therapy and the notes taken at your session. Paper
            documents will be scanned and stored electronically and then will be
            shredded upon completion of your therapy.
          </p>{" "}
          <h3> How to contact me</h3>
          <p>
            {" "}
            If you have any questions about how I handle your personal data, you
            can contact me as follows:{" "}
          </p>
          <ul className="noDecoration">
            <li>Georgina Taylor-Wyatt </li>
            <li>GTW Hypnotherapy </li>
            <li>Stable Park</li>
            <li> Effingham Road</li>
            <li> Copthorne</li>
            <li>Crawley</li>
            <li>West Sussex</li>
            <li> RH10 3HY </li>
            <li>info@gtw-hypnotherapy.co.uk</li>{" "}
          </ul>
          <p>
            If you believe I am processing your personal data not in accordance
            with the law, you can complain to the Information Commissioner’s
            Office.
          </p>
          <p className="lastParagraph">
            <a href="https://ico.org.uk/" target="_blank" rel="noReferrer">
              https://ico.org.uk/
            </a>
          </p>
        </div>
      </article>
    </>
  );
};

export default PrivacyPolicy;
